module.exports = __webpack_public_path__ + "img/SCKL12.png";